export const getProductTypeImageUrl = (
  id: string,
  { height = 100, width = 100 }: { height?: number; width?: number } = {},
): string => {
  return `https://image.spreadshirtmedia.${
    SPRD.PLATFORM === 'EU' ? 'net' : 'com'
  }/image-server/v1/productTypes/${id}?width=${width},height=${height}`;
};

export const getCountryImageUrl = (countryCode: string): string => {
  return `images/flags/${countryCode.toLowerCase()}.svg`;
};

export const getDesignImageUrl = (
  designId: number,
  { height = 100, width = 100 }: { height?: number; width?: number } = {},
): string => {
  return `https://image.spreadshirtmedia.${
    SPRD.PLATFORM === 'EU' ? 'net' : 'com'
  }/image-server/v1/designs/${designId},width=${width},height=${height}`;
};

export const getCombinedDesignsImageUrl = (
  designs: number[],
  { height = 100, width = 100 }: { height?: number; width?: number } = {},
) => {
  return `https://image.spreadshirtmedia.${
    SPRD.PLATFORM === 'EU' ? 'net' : 'com'
  }/image-server/v2/designs/collage,designIds=${designs.join('-')},width=${width},height=${height}`;
};
